/* Ben's onboarding tracker (2026-11-02): his steps, in his order, one tick each. */

export const TRACKER_STEPS = [
  { id: "telegram", label: "Telegram" },
  { id: "links", label: "Links setup" },
  { id: "call", label: "Call" },
  { id: "plan", label: "Plan" },
  { id: "flows", label: "Flows" },
  { id: "ig", label: "IG accounts" },
  { id: "twitter", label: "Twitter" },
  { id: "reddit", label: "Reddit" },
] as const;

export type TrackerStep = (typeof TRACKER_STEPS)[number]["id"];

export const isTrackerStep = (value: string): value is TrackerStep => TRACKER_STEPS.some((s) => s.id === value);

/**
 * The lines each creator starts with under a step (Jay, 2026-11-04), from Ben's whiteboard and Jay's
 * tech list of 2 Nov. Each creator's copy is theirs: add, rename or delete lines in their side panel.
 */
export const DEFAULT_SUBITEMS: Record<TrackerStep, string[]> = {
  telegram: ["Groups made: main chat, IG, Reddit, Twitter, TikTok, leaks", "Creator added to every group"],
  links: ["Links made in Links", "Infloww tracking and free trial links made", "Added to the INFLOWW LINKS sheet"],
  call: ["Intro call done", "ID photos, address and details provided"],
  plan: ["Plan written", "Platforms and content agreed"],
  flows: ["Signet set up", "Drives and flows made", "Main IG accounts added", "Auto-Downloads set up, backdated if needed"],
  ig: ["Number of IG Suicide accounts decided", "Accounts assigned to phones"],
  twitter: ["Twitter account made", "Profile set up: photo, bio, link"],
  reddit: ["RedGifs made and photo asked for", "Poster assigned and sheet set up"],
};

export type TrackerTick = { at: string; by: string | null };

export type TrackerSubitem = { id: string; step: TrackerStep; label: string; done: TrackerTick | null };

export type TrackerCreator = {
  creator: string;
  addedAt: string;
  ticks: Partial<Record<TrackerStep, TrackerTick>>;
  plan: string;
  notes: string;
  updatedAt: string;
  updatedBy: string | null;
  subitems: TrackerSubitem[];
  /** Main Accounts' handles for this creator, so the side panel shows what is there already. */
  mainAccounts: string[];
};

export type Tracker = { creators: TrackerCreator[]; available: string[] };

/** Every step ticked. */
export const isComplete = (c: Pick<TrackerCreator, "ticks">): boolean => TRACKER_STEPS.every((s) => Boolean(c.ticks[s.id]));

export const progressOf = (c: Pick<TrackerCreator, "ticks">): number =>
  Math.round((TRACKER_STEPS.filter((s) => c.ticks[s.id]).length / TRACKER_STEPS.length) * 100);
